const e=async(e,t)=>{await e.post(`/auth/mfa/method/disable`,{method:t})};export{e as disableMfaMethod};
//# sourceMappingURL=disable-mfa-method.mjs.map